export const EVENT_TOAST_SHOW = 'event-toast-show'
export const EVENT_STATIC_TOAST_SHOW = 'event-static-show'
export const AVAILABLE_COLOURS = ['green', 'red', 'orange', 'blue'];
export const AVAILABLE_VARIANTS = ['success', 'danger', 'warning', 'info'];
